<template>
  <div class="acts-editor-state">
    <divider orientation="left">Основные сведения</divider>
    <div class="acts-editor-state__act-status">
      <row :gutter="16">
        <i-col span="12">
          <span class="ms-help label">Статус акта</span>
          <i-select
            :disabled="!getContractModulePerms('contract_acts', 'update')"
            size="default"
            v-model="act.act_status_id"
            @on-change="changeStatusHandler"
          >
            <i-option
              v-for="status in actStatuses"
              :value="status.id"
              :key="status.id"
            >
              {{ status.name }}
            </i-option>
          </i-select>
        </i-col>
        <i-col span="12">
          <div class="acts-editor-state__act-original">
            <checkbox size="large" v-model="act.is_original_exists">
              Оригинал получен
            </checkbox>
          </div>
        </i-col>
      </row>
    </div>
    <row :gutter="16">
      <i-col span="12">
        <span class="ms-help label">Номер акта</span>
        <i-input
          :disabled="!getContractModulePerms('contract_acts', 'update')"
          v-model="act.number"
          placeholder="№ акта"
        />
      </i-col>
    </row>
    <row :gutter="16" style="margin-top: 8px;" v-if="datesRowAvailable">
      <i-col span="12">
        <span class="ms-help label">Дата отправки Заказчику</span>
        <date-picker
          format="dd.MM.yyyy"
          placeholder="Выберите дату"
          v-model="act.send_date"
          @on-change="sendDateChangeHandler"
          :disabled="!getContractModulePerms('contract_acts', 'update')"
        />
      </i-col>
      <i-col span="12" v-if="signDateAvailable">
        <span class="ms-help label">Дата подписания</span>
        <date-picker
          format="dd.MM.yyyy"
          placeholder="Выберите дату"
          v-model="act.sign_date"
          :disabled="!getContractModulePerms('contract_acts', 'update')"
        />
      </i-col>
    </row>
  </div>
</template>

<script>
export default {
  props: ['act', 'act-statuses'],
  computed: {
    currentStatus () {
      const { act_status_id } = this.act

      if (act_status_id) {
        return this.actStatuses.find((s) => s.id === act_status_id)
      }

      return {}
    },
    datesRowAvailable () {
      if (!this.act.act_roadmaps.length) return false

      return true
    },
    signDateAvailable () {
      const { name } = this.currentStatus
      const { send_date } = this.act

      return send_date && (name === 'Подписан' || name === 'Оплачен')
    },
    roadmapMinDate () {
      const { act_roadmaps } = this.act
      let min = new Date(act_roadmaps[0].roadmap_start_date)

      for (let i = 0; i < act_roadmaps.length; i++) {
        const stage = act_roadmaps[i]
        const { roadmap_start_date } = stage
        const current = new Date(roadmap_start_date)

        if (current.valueOf() <= min.valueOf()) {
          min = current
        }
      }

      return min
    }
  },
  methods: {
    changeStatusHandler () {
      const { name } = this.currentStatus

      if (name !== 'Подписан' && name !== 'Оплачен') {
        this.$set(this.act, 'sign_date', '')
      }

      if (name === 'На согласовании в компании') {
        this.$set(this.act, 'send_date', '')
      }
    },
    sendDateChangeHandler (value) {
      if (!value) {
        this.$set(this.act, 'sign_date', null)
      }
    }
  }
}
</script>

<style lang="less">
.acts-editor-state {
  &__act-status {
    margin-bottom: 8px;
  }

  &__act-original {
    margin-top: 18px;

    span {
      margin-right: 2px;
    }
  }

  .ivu-date-picker {
    width: 100%;
  }
}
</style>
